import React from 'react'
import {
    TextField, 
    FormControlLabel,
    Checkbox,
    RadioGroup,
    FormControl,
    Select,
    OutlinedInput,
    InputLabel,
    Chip,
    FormHelperText
} from '@material-ui/core'
import YomaEditor from '../../components/YomaEditor'
import {InlineDatePicker} from 'material-ui-pickers'
import {
    stateToHTML
} from 'draft-js-export-html'

export const renderTextField = ({ 
    style, 
    type, 
    input, 
    label,
    disabled, 
    meta: {touched, error, warning}, ...custom }) => (
    <div>
        <TextField
            className={style}
            disabled={disabled}
            label={label}
            variant="outlined"
            fullWidth
            type={type}
            {...input}
            {...custom}
    />

    {touched &&
        ((error && <span style={{ color: "red" }}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
    
)

export const renderTextArea = ({input, label, meta: {touched, error, warning}, ...custom }) => (
    <div>
        <TextField
            label={label}
            variant="outlined"
            fullWidth
            multiline
            rows={10}
            margin="normal"
            error = {touched && error}
            {...input}
            {...custom}
        />
        {touched &&
            ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
    </div>
)

export const renderEditor = ({input, init_value, label, meta: {touched, error, warning}, ...custom }) => (
    <YomaEditor 
        placeholder={label}
        value={init_value} 
        onChange={(value) => 
        input.onChange(stateToHTML(value))
        } 
    />
)

export const renderCheckBox = ({ input,label, meta: {touched, error, warning} }) => (
   <div>
        <FormControlLabel
            control = {
                <Checkbox
                    value={input.value}
                    checked={input.checked}
                    onChange={(value) => {
                        input.onChange(value)
                    }}
                />
            }
            label={label}
        />

        {touched &&
            ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
   </div>
    
)

export const renderRadioGroup = ({ input, meta: {touched, error, warning}, ...rest }) => (
    <div>
        <RadioGroup
            {...input}
            {...rest}
            valueselected={input.value}
            onChange={(value) => input.onChange(value)}
            row
        />

        {
            touched &&
            ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))
        }
    </div>
    
)

export const renderSelect = ({style, input, label, label_width, meta: { touched, error, warning}, children, ...custom}) => (

    <FormControl 
        fullWidth
        variant="outlined" 
        className={style} 
        error={touched && error}
        >
            <InputLabel htmlFor="single-selected">{label}</InputLabel>
            <Select
                fullWidth
                variant="outlined"
                placeholder="label"
                label={label}
                input={
                    <OutlinedInput 
                        id="single-selected" 
                        labelWidth={label_width}/>
                }
                {...input}
                {...custom}
                inputProps={{
                    name: 'category',
                    id: 'job-category'
                }}
            >
                {children}
            </Select>
            
          {
              renderFormHelper({touched, error})
          }
        
    </FormControl>
)

const renderFormHelper = ({touched, error}) => {
    if(!(touched && error)) {
        return
    }else{
        return <FormHelperText> {touched && error}</FormHelperText>
    }
}

export const renderMultipleSelect = ({style, input, selected_value, default_value,label, meta: { touched, error}, children, ...custom}) => (
    <FormControl 
        fullWidth
        variant="outlined" 
        className={style} 
        error={touched && error}>

        <InputLabel htmlFor="multiple-select">
        {label}
        </InputLabel>
        <Select
            multiple
            value={selected_value}
            fullWidth
            onChange={(value) => input.onChange(value) }
            input = { <OutlinedInput id="multiple-select" labelWidth={75} name="length_of_advertisement"/>}
            renderValue={ selected => (
                <div>
                    {
                        selected.map( (value, key) => (
                           <Chip key={key} label={value} />
                        ))
                    }
                </div>
            )}
        >

            {children}

        </Select>
    </FormControl>                
)

export const renderDatePicker = ({style, input, label, placeholder, meta: { touched, error, warning}, children, ...custom}) => (
    <div>
        <InlineDatePicker
                className={style}
                keyboard
                variant="outlined"
                margin="normal"
                fullWidth
                label={label}
                minDate={new Date()}
                placeholder={placeholder}
                value={input.value}
                error = {touched && error}
                format={"YYYY-MM-DD"}
                mask={[/\d/, /\d/, /\d/, /\d/,'-',/\d/, /\d/, '-', /\d/, /\d/ ]}
                onChange={input.onChange}
                {...input}
                {...custom}
            />
        {
            touched &&
            ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))
        }
    </div>
    
)

// export const renderTextArea = ({style, input, label, meta: { touched, error}, children, ...custom}) => (



// )